import axios from 'axios';

const host = process.env.VUE_APP_URL_API;

export default class ValidProgramId {
  doValidProgramId(programId) {
    this.path = `/checkout/${programId}`;
    this.url = host + this.path;
    return axios.get(this.url);
  }
}
